"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalShockFrostAbilityHandler = exports.ElementalShockFrostActorAbilityFactory = exports.ElementalShockFrostAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class ElementalShockFrostAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalShockFrost;
        this.__typeName = "ElementalShockFrost";
    }
}
exports.ElementalShockFrostAbilityArgs = ElementalShockFrostAbilityArgs;
let ElementalShockFrostActorAbilityFactory = class ElementalShockFrostActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalShockFrost", "Self", 0);
    }
};
ElementalShockFrostActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalShockFrost")
], ElementalShockFrostActorAbilityFactory);
exports.ElementalShockFrostActorAbilityFactory = ElementalShockFrostActorAbilityFactory;
let ElementalShockFrostAbilityHandler = class ElementalShockFrostAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Elemental Shock: Frost", "Chills killer", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "ApplyEffects_OnKilled", {
                target: "killer",
                effects: [{
                        duration: Duration_1.Duration.Ticks(8),
                        effect: new core_1.ChillEffectArgs("Focus", 20),
                        percentChance: 100
                    }]
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
ElementalShockFrostAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalShockFrost)
], ElementalShockFrostAbilityHandler);
exports.ElementalShockFrostAbilityHandler = ElementalShockFrostAbilityHandler;
